// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ChatPageV2_chatPage__gC8c5 {
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 64px);
  background: var(--white);
  font-family: var(--font-inter);
  position: relative;
  overflow-x: hidden;
}

.ChatPageV2_pageHeader__FyWw3 {
  background: var(--white);
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
}
.ChatPageV2_pageHeader__FyWw3 .ChatPageV2_headerLeft__oIBRg {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ChatPageV2_pageHeader__FyWw3 h1 {
  font: var(--h3);
  font-family: var(--font-bodoni-72);
  font-weight: 700;
  color: var(--primary-Text);
  margin: 0;
}
@media (max-width: 1280px) {
  .ChatPageV2_pageHeader__FyWw3 {
    padding: 10px 15px;
  }
}
@media (max-width: 768px) {
  .ChatPageV2_pageHeader__FyWw3 {
    min-height: 64px;
  }
  .ChatPageV2_pageHeader__FyWw3 h1 {
    font-size: 24px;
  }
}

.ChatPageV2_groupModal__e82tK {
  padding: 0;
}
.ChatPageV2_groupModal__e82tK .ChatPageV2_subHeader__EKsFQ {
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: #9BA4B5;
  margin-bottom: 8px;
}

.ChatPageV2_groupTitleInput__RhYZ9 {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  color: #000;
  text-transform: capitalize;
  padding-left: 0;
  margin-bottom: 12px;
}
.ChatPageV2_groupTitleInput__RhYZ9::placeholder {
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  color: #98a2b1;
}

.ChatPageV2_mobileMenuBtn__33rR8 {
  display: none;
}
@media (max-width: 768px) {
  .ChatPageV2_mobileMenuBtn__33rR8 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: none;
    background: var(--bg3);
    border-radius: 8px;
    cursor: pointer;
    font-size: 18px;
    color: var(--placeholder);
  }
  .ChatPageV2_mobileMenuBtn__33rR8:hover {
    background: var(--border);
  }
}

.ChatPageV2_pageHeaderRight__swnex {
  display: flex;
  align-items: center;
  gap: 24px;
}
.ChatPageV2_pageHeaderRight__swnex .ChatPageV2_dateText__hO2O3 {
  color: var(--secondary-Text);
  font-size: 16px;
  font-weight: 500;
}
@media (max-width: 768px) {
  .ChatPageV2_pageHeaderRight__swnex {
    gap: 12px;
  }
  .ChatPageV2_pageHeaderRight__swnex .ChatPageV2_dateText__hO2O3 {
    display: none;
  }
}

.ChatPageV2_chatWrapper__lGSxA {
  display: flex;
  flex: 1 1;
  overflow: hidden;
  background: var(--white);
  position: relative;
}
@media (max-width: 768px) {
  .ChatPageV2_chatWrapper__lGSxA {
    position: unset;
  }
}

/* Sidebar */
.ChatPageV2_chatSidebar__N2d5v {
  width: 360px;
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  background: var(--white);
}
@media (max-width: 1280px) {
  .ChatPageV2_chatSidebar__N2d5v {
    width: 300px;
  }
}
@media (max-width: 1024px) {
  .ChatPageV2_chatSidebar__N2d5v {
    width: 260px;
  }
}
@media (max-width: 768px) {
  .ChatPageV2_chatSidebar__N2d5v {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .ChatPageV2_chatWindow__vC0ww {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    max-width: 100%;
    z-index: 1;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
  .ChatPageV2_chatWindow__vC0ww.ChatPageV2_open__TlPMu {
    transform: translateX(0);
  }
}

.ChatPageV2_sidebarTabs__mYiba {
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
}
@media (max-width: 1280px) {
  .ChatPageV2_sidebarTabs__mYiba {
    padding: 10px 15px;
  }
}
.ChatPageV2_sidebarTabs__mYiba .ChatPageV2_tabs__o4z3B {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
  padding: 4px;
  background: var(--bg3);
  border-radius: 12px;
}
.ChatPageV2_sidebarTabs__mYiba button {
  flex: 1 1;
  padding: 4px 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  color: var(--secondary-Text);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.ChatPageV2_sidebarTabs__mYiba button img {
  filter: grayscale(100%);
}
.ChatPageV2_sidebarTabs__mYiba button.ChatPageV2_active__wtETX {
  background: var(--white);
  color: var(--brand);
  font-weight: 600;
}
.ChatPageV2_sidebarTabs__mYiba button.ChatPageV2_active__wtETX img {
  filter: grayscale(0%);
}
.ChatPageV2_sidebarTabs__mYiba button:focus-visible, .ChatPageV2_sidebarTabs__mYiba button:focus {
  outline: none;
  box-shadow: none;
}
@media (max-width: 1280px) {
  .ChatPageV2_sidebarTabs__mYiba button {
    font-size: 12px;
  }
}
.ChatPageV2_sidebarTabs__mYiba img {
  color: var(--brand);
}
.ChatPageV2_sidebarTabs__mYiba img.ChatPageV2_active__wtETX {
  background: var(--white);
  color: var(--brand);
  font-weight: 600;
}

.ChatPageV2_tabIndicator__hOTZm {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  background: #ff3b30;
  border-radius: 50%;
  border: 2px solid var(--white);
  animation: ChatPageV2_pulse__Xrb5z 2s infinite;
}

@keyframes ChatPageV2_pulse__Xrb5z {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}
.ChatPageV2_sidebarButton__cDszw button {
  flex: 1 1;
  padding: 4px 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  color: var(--brand);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.ChatPageV2_sidebarButton__cDszw button.ChatPageV2_active__wtETX {
  background: var(--white);
  color: var(--brand);
  font-weight: 600;
}
.ChatPageV2_sidebarButton__cDszw img {
  color: var(--brand);
}
.ChatPageV2_sidebarButton__cDszw img.ChatPageV2_active__wtETX {
  background: var(--white);
  color: var(--brand);
  font-weight: 600;
}

.ChatPageV2_searchContainer__V\\+NhO {
  padding: 20px 24px;
}
@media (max-width: 1280px) {
  .ChatPageV2_searchContainer__V\\+NhO {
    padding: 10px 15px;
  }
}

.ChatPageV2_modalBody__GcJmL .ChatPageV2_searchContainer__V\\+NhO {
  padding: 0;
  padding-bottom: 20px;
}
.ChatPageV2_modalBody__GcJmL .ChatPageV2_chatList__FP1sx {
  padding: 0;
}
.ChatPageV2_modalBody__GcJmL .ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC {
  background-color: var(--white);
  border: 1px solid var(--border);
}
.ChatPageV2_modalBody__GcJmL .ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20 {
  width: 38px;
  height: 38px;
}

.ChatPageV2_groupModal__e82tK {
  padding: 0;
}

.ChatPageV2_chatList__FP1sx {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1 1;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
  padding: 0 24px;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatList__FP1sx {
    padding: 0 15px;
  }
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;
  border-radius: 8px;
  width: 100%;
  max-width: 100%;
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC:hover {
  background: var(--bg3);
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC.ChatPageV2_selected__0Kqn2 {
  background: var(--bg3);
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20 {
  position: relative;
  width: 48px;
  height: 48px;
  margin-right: 16px;
  flex-shrink: 0;
  display: inline-block;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20 {
    width: 35px;
    height: 35px;
    margin-right: 8px;
  }
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__img__Atv2- {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20::after {
  content: "";
  position: absolute;
  bottom: 4px;
  right: 4px;
  transform: translate(25%, 25%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid var(--white);
  box-sizing: content-box;
  background: var(--placeholder);
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20.ChatPageV2_group__WjKu6::after {
  visibility: hidden;
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20.ChatPageV2_online__7OGTI::after {
  background: var(--success);
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20.ChatPageV2_offline__zvj6u::after {
  background: var(--placeholder);
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20.ChatPageV2_away__J-cEE::after {
  background: var(--warning);
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_chatInfo__WDAOQ {
  flex: 1 1;
  min-width: 0;
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_chatInfo__WDAOQ .ChatPageV2_userName__StpY6 {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_chatInfo__WDAOQ .ChatPageV2_userName__StpY6 {
    font-size: 14px;
  }
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_chatInfo__WDAOQ .ChatPageV2_lastMessage__kyOB3 {
  font-size: 14px;
  color: var(--secondary-Text);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  text-align: start;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_chatInfo__WDAOQ .ChatPageV2_lastMessage__kyOB3 {
    font-size: 12px;
  }
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_chatMeta__-oyon {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
  margin-left: 12px;
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_timeStamp__mAMBm {
  font-size: 13px;
  color: #94a3b8;
  flex-shrink: 0;
}
.ChatPageV2_chatList__FP1sx .ChatPageV2_chatItem__20RCC .ChatPageV2_unreadBadge__4N4Y6 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: #10B981;
  color: white;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.ChatPageV2_chatListGroup__QxuCW.ChatPageV2_chatList__FP1sx {
  gap: 0;
}
.ChatPageV2_chatListGroup__QxuCW .ChatPageV2_chatItem__20RCC {
  padding: 8px 12px;
}
.ChatPageV2_chatListGroup__QxuCW .ChatPageV2_chatItem__20RCC:hover, .ChatPageV2_chatListGroup__QxuCW .ChatPageV2_chatItem__20RCC.ChatPageV2_selected__0Kqn2 {
  background: transparent;
}
.ChatPageV2_chatListGroup__QxuCW .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20 {
  position: relative;
  width: 40px;
  height: 40px;
  margin-right: 12px;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatListGroup__QxuCW .ChatPageV2_chatItem__20RCC .ChatPageV2_avatar__uca20 {
    width: 30px;
    height: 30px;
    margin-right: 8px;
  }
}

/* Chat Window */
.ChatPageV2_chatWindow__vC0ww {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--white);
  height: 100%;
}

.ChatPageV2_chatHeader__w\\+NWa {
  display: flex;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid var(--border);
  background: var(--white);
  min-height: 80px;
  width: 100%;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatHeader__w\\+NWa {
    padding: 10px 15px;
    min-height: 69px;
  }
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_arrowBack__akmsX {
  display: none;
}
@media (max-width: 768px) {
  .ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_arrowBack__akmsX {
    display: flex;
  }
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_avatar__uca20 {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-right: 16px;
  object-fit: cover;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_avatar__uca20 {
    width: 30px;
    height: 30px;
    margin-right: 8px;
  }
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 {
  flex: 1 1;
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userName__StpY6 {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userName__StpY6 {
    font-size: 18px;
  }
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userStatus__hp0Px {
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: capitalize;
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userStatus__hp0Px::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userStatus__hp0Px.ChatPageV2_online__7OGTI {
  color: var(--success);
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userStatus__hp0Px.ChatPageV2_online__7OGTI::before {
  background: var(--success);
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userStatus__hp0Px.ChatPageV2_offline__zvj6u {
  color: var(--placeholder);
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userStatus__hp0Px.ChatPageV2_offline__zvj6u::before {
  background: var(--placeholder);
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userStatus__hp0Px.ChatPageV2_away__J-cEE {
  color: var(--warning);
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userInfo__qjGo3 .ChatPageV2_userStatus__hp0Px.ChatPageV2_away__J-cEE::before {
  background: var(--warning);
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_headerActions__NZaE0 {
  background-color: transparent !important;
  border: transparent !important;
  color: var(--white) !important;
  box-shadow: none !important;
  width: 20px;
  height: 20px;
}
.ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_headerActions__NZaE0 span {
  padding: 0;
}
@media (max-width: 768px) {
  .ChatPageV2_chatHeader__w\\+NWa {
    padding: 16px 20px;
    min-height: 64px;
  }
  .ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_avatar__uca20 {
    width: 44px;
    height: 44px;
  }
  .ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userName__StpY6 {
    font-size: 18px;
  }
  .ChatPageV2_chatHeader__w\\+NWa .ChatPageV2_userStatus__hp0Px {
    font-size: 13px;
  }
}

.ChatPageV2_messagesContainer__snSh8 {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background: var(--white);
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
}
@media (max-width: 768px) {
  .ChatPageV2_messagesContainer__snSh8 {
    padding: 16px 20px;
  }
}

.ChatPageV2_messageGroup__YMurl {
  margin-bottom: 24px;
}
@media (max-width: 1280px) {
  .ChatPageV2_messageGroup__YMurl {
    margin-bottom: 18px;
  }
}
.ChatPageV2_messageGroup__YMurl.ChatPageV2_received__4bDkk .ChatPageV2_messageWrapper__WjBJ9 {
  justify-content: flex-start;
  align-items: flex-start;
  gap: 7px;
}
.ChatPageV2_messageGroup__YMurl.ChatPageV2_received__4bDkk .ChatPageV2_message__lYn6a .ChatPageV2_messageBubble__N9Ncn {
  background: var(--bg3);
  color: #1e293b;
  word-break: break-word;
}
.ChatPageV2_messageGroup__YMurl.ChatPageV2_sent__0jCWD .ChatPageV2_messageWrapper__WjBJ9 {
  justify-content: flex-end;
  align-items: flex-end;
  gap: 7px;
}
.ChatPageV2_messageGroup__YMurl.ChatPageV2_sent__0jCWD .ChatPageV2_messageAvatar__UKM6a {
  order: 2;
  margin-left: 16px;
  margin-right: 0;
  margin-bottom: 22px;
}
@media (max-width: 1280px) {
  .ChatPageV2_messageGroup__YMurl.ChatPageV2_sent__0jCWD .ChatPageV2_messageAvatar__UKM6a {
    margin-left: 6px;
  }
}
.ChatPageV2_messageGroup__YMurl.ChatPageV2_sent__0jCWD .ChatPageV2_messageContent__fR4zm {
  align-items: flex-end;
}
.ChatPageV2_messageGroup__YMurl.ChatPageV2_sent__0jCWD .ChatPageV2_message__lYn6a .ChatPageV2_messageBubble__N9Ncn {
  background: var(--brand);
  color: var(--white);
  word-break: break-word;
}
.ChatPageV2_messageGroup__YMurl.ChatPageV2_sent__0jCWD .ChatPageV2_messageTime__Rtrxx {
  text-align: right;
}

.ChatPageV2_messageWrapper__WjBJ9 {
  display: flex;
  align-items: flex-start;
  margin-bottom: 4px;
}

.ChatPageV2_messageAvatar__UKM6a {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 16px;
  flex-shrink: 0;
  object-fit: cover;
  margin-bottom: 22px;
}
@media (max-width: 1280px) {
  .ChatPageV2_messageAvatar__UKM6a {
    margin-right: 6px;
  }
}

.ChatPageV2_avatarWrapper__6vEuG {
  position: relative;
  display: inline-block;
  margin-right: 0;
  flex-shrink: 0;
}

.ChatPageV2_onlineIndicator__jo4t6 {
  position: absolute;
  bottom: 20px;
  right: 16px;
  width: 12px;
  height: 12px;
  background: #10b981;
  border: 2px solid var(--white);
  border-radius: 50%;
  z-index: 1;
}

.ChatPageV2_awayIndicator__0NxHr {
  position: absolute;
  bottom: 22px;
  right: 16px;
  width: 12px;
  height: 12px;
  background: #f59e0b;
  border: 2px solid var(--white);
  border-radius: 50%;
  z-index: 1;
}

.ChatPageV2_messageContent__fR4zm {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 65%;
}
.ChatPageV2_messageContent__fR4zm .ChatPageV2_senderName__j2jpx {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 10px;
  color: var(--brand);
  text-transform: capitalize;
  letter-spacing: 0.3px;
}
@media (max-width: 768px) {
  .ChatPageV2_messageContent__fR4zm {
    max-width: 80%;
  }
}

.ChatPageV2_message__lYn6a .ChatPageV2_messageBubble__N9Ncn {
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 15px;
  line-height: 1.4;
  word-wrap: break-word;
  margin-bottom: 10px;
  width: fit-content;
}
.ChatPageV2_message__lYn6a .ChatPageV2_messageBubble__N9Ncn:last-child {
  margin-bottom: 0;
}

.ChatPageV2_messageTime__Rtrxx {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 10px;
  padding: 0 6px;
}

/* File Attachments */
.ChatPageV2_fileAttachment__OYJj6 {
  margin: 0 -8px;
  margin-bottom: 8px;
}
.ChatPageV2_fileAttachment__OYJj6 .ChatPageV2_attachedImage__kMFjv {
  width: 280px;
  height: 280px;
  border-radius: 10px;
  cursor: pointer;
  object-fit: cover;
  display: block;
}
@media (max-width: 768px) {
  .ChatPageV2_fileAttachment__OYJj6 .ChatPageV2_attachedImage__kMFjv {
    width: 220px;
    height: 220px;
  }
}
.ChatPageV2_fileAttachment__OYJj6 .ChatPageV2_attachedVideo__eYBGg {
  width: 280px;
  height: 280px;
  border-radius: 8px;
  display: block;
  object-fit: cover;
}
@media (max-width: 768px) {
  .ChatPageV2_fileAttachment__OYJj6 .ChatPageV2_attachedVideo__eYBGg {
    width: 220px;
    height: 220px;
  }
}
.ChatPageV2_fileAttachment__OYJj6 .ChatPageV2_fileLink__Auiaj {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  transition: background 0.2s ease;
}
.ChatPageV2_fileAttachment__OYJj6 .ChatPageV2_fileLink__Auiaj:hover {
  background: rgba(255, 255, 255, 0.2);
}
.ChatPageV2_fileAttachment__OYJj6 .ChatPageV2_fileLink__Auiaj img {
  width: 24px;
  height: 24px;
}
.ChatPageV2_fileAttachment__OYJj6 .ChatPageV2_fileLink__Auiaj span {
  font-size: 14px;
  font-weight: 500;
}

.ChatPageV2_selectedFilePreview__uxUf0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: var(--bg3);
  border-radius: 8px;
  margin-bottom: 8px;
  width: 100%;
}
.ChatPageV2_selectedFilePreview__uxUf0 span {
  font-size: 14px;
  color: var(--primary-Text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
}
.ChatPageV2_selectedFilePreview__uxUf0 button {
  background: transparent;
  border: none;
  font-size: 24px;
  color: var(--secondary-Text);
  cursor: pointer;
  padding: 0;
  margin-left: 12px;
  line-height: 1;
}
.ChatPageV2_selectedFilePreview__uxUf0 button:hover {
  color: var(--primary-Text);
}

.ChatPageV2_dateDivider__LgNZt {
  text-align: center;
  margin: 32px 0;
  position: relative;
}
.ChatPageV2_dateDivider__LgNZt::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--border);
}
.ChatPageV2_dateDivider__LgNZt span {
  background: var(--white);
  padding: 4px 12px;
  font-size: 13px;
  color: var(--secondary-Text);
  font-weight: 500;
  position: relative;
  z-index: 1;
  border: 1px solid var(--border);
  border-radius: 500px;
}

/* Upload Loader */
.ChatPageV2_uploadingMediaWrapper__guOXg {
  position: relative;
  display: inline-block;
}

.ChatPageV2_uploading__4Ehf\\+ {
  filter: blur(4px);
  opacity: 0.5;
}

.ChatPageV2_uploadOverlay__YMuQG {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
}

.ChatPageV2_loaderContainer__NttQX {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.ChatPageV2_circularLoader__3idKn {
  width: 50px;
  height: 50px;
  border: 5px dotted var(--white);
  border-radius: 50%;
  animation: ChatPageV2_spin__km92v 1.2s linear infinite;
}

.ChatPageV2_uploadingText__JKNpl {
  color: var(--white);
  font-size: 16px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

@keyframes ChatPageV2_spin__km92v {
  to {
    transform: rotate(360deg);
  }
}
/* Chat Input */
.ChatPageV2_chatInput__DSL8C {
  display: flex;
  align-items: center;
  background: var(--white);
  padding: 24px;
  padding-top: 5px;
  gap: 12px;
  width: 100%;
  /* Input Wrapper (contains text + send) */
  /* 📱 Mobile Responsive */
}
.ChatPageV2_chatInput__DSL8C .ChatPageV2_chatInputAttachBtn__Vfz5s {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ChatPageV2_chatInput__DSL8C .ChatPageV2_chatInputBtn__eyg\\+M {
  background: transparent;
  border: none;
  padding-right: 20px;
}
.ChatPageV2_chatInput__DSL8C .ChatPageV2_inputWrapper__1GtV3 {
  flex: 1 1;
  display: flex;
  align-items: center;
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 24px;
  padding: 0;
  transition: all 0.2s ease;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatInput__DSL8C .ChatPageV2_inputWrapper__1GtV3 {
    border-radius: 18px;
  }
}
.ChatPageV2_chatInput__DSL8C .ChatPageV2_inputWrapper__1GtV3:focus-within {
  border-color: var(--secondary-Text);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.ChatPageV2_chatInput__DSL8C .ChatPageV2_inputWrapper__1GtV3 input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 15px;
  color: var(--primary-Text);
  padding: 15px 20px;
  outline: none;
}
@media (max-width: 1280px) {
  .ChatPageV2_chatInput__DSL8C .ChatPageV2_inputWrapper__1GtV3 input {
    padding: 10px 15px;
    margin: 7px 0;
  }
}
.ChatPageV2_chatInput__DSL8C .ChatPageV2_inputWrapper__1GtV3 input::placeholder {
  color: var(--placeholder);
}
@media (max-width: 768px) {
  .ChatPageV2_chatInput__DSL8C {
    padding: 24px 20px;
    gap: 8px;
  }
  .ChatPageV2_chatInput__DSL8C .ChatPageV2_chatInputAttachBtn__Vfz5s,
  .ChatPageV2_chatInput__DSL8C .ChatPageV2_chatInputBtn__eyg\\+M {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ChatPageV2_chatInput__DSL8C .ChatPageV2_inputWrapper__1GtV3 {
    border-radius: 20px;
  }
  .ChatPageV2_chatInput__DSL8C .ChatPageV2_inputWrapper__1GtV3 input {
    font-size: 14px;
  }
}

/* Empty state */
.ChatPageV2_emptyState__47tQc {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  text-align: center;
  padding: 40px;
  color: var(--secondary-Text);
}
.ChatPageV2_emptyState__47tQc .ChatPageV2_emptyIcon__GSvDo {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}
.ChatPageV2_emptyState__47tQc h3 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #334155;
}
.ChatPageV2_emptyState__47tQc p {
  font-size: 16px;
  margin: 0;
  opacity: 0.8;
}

/* Mobile overlay */
.ChatPageV2_mobileOverlay__f\\+VbZ {
  display: none;
}
@media (max-width: 1024px) {
  .ChatPageV2_mobileOverlay__f\\+VbZ {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 2;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }
  .ChatPageV2_mobileOverlay__f\\+VbZ.ChatPageV2_active__wtETX {
    opacity: 1;
    pointer-events: auto;
  }
}

/* Utility classes */
@media (max-width: 768px) {
  .ChatPageV2_sidebarOpen__nFbt5 .ChatPageV2_chatSidebar__N2d5v {
    transform: translateX(0);
  }
}

.ChatPageV2_groupInfo__MkVgC {
  border-right: 1px solid var(--border);
  border-left: 1px solid var(--border);
  background-color: var(--white);
  width: 0;
  transform: translateX(100%);
  transition: all 0.3s;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
}
.ChatPageV2_groupInfo__MkVgC.ChatPageV2_open__TlPMu {
  transform: translateX(0);
  width: 310px;
  transition: all 0.3s;
}
@media (max-width: 1024px) {
  .ChatPageV2_groupInfo__MkVgC {
    position: absolute;
    width: 320px;
    top: 0;
    right: 0;
    z-index: 2;
  }
}
@media (max-width: 768px) {
  .ChatPageV2_groupInfo__MkVgC {
    position: absolute;
    width: 320px;
  }
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoDetailsMain__kDD81 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 24px;
  padding-top: 16px;
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoDetailsMain__kDD81 .ChatPageV2_uploadCircle__yCRZH {
  width: 96px;
  height: 96px;
  border-radius: 500px;
  border: 2px solid var(--border);
  background-color: var(--white);
  color: var(--secondary-Text);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: relative;
  font: var(--body-font-four);
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoDetailsMain__kDD81 .ChatPageV2_uploadCircle__yCRZH span {
  font: var(--body-font-four);
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoDetailsMain__kDD81 .ChatPageV2_cameraIcon__J8ba7 {
  position: absolute;
  bottom: 0px;
  right: 0px;
  background-color: var(--brand);
  color: var(--white);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoDetailsMain__kDD81 .ChatPageV2_cameraIcon__J8ba7 img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
  filter: brightness(0) invert(1);
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoDetailsMain__kDD81 .ChatPageV2_groupInfoDetails__-7ERv h3 {
  font: var(--h6);
  font-weight: 600;
  color: var(--primary-Text);
  text-align: center;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoDetailsMain__kDD81 .ChatPageV2_groupInfoDetails__-7ERv h3 img {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoDetailsMain__kDD81 .ChatPageV2_groupInfoDetails__-7ERv p {
  margin: 0;
  margin-top: 6px;
  font: var(--body-font-four);
  color: var(--secondary-Text);
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoActions__fE4w2 {
  padding: 16px 24px 20px 24px;
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: var(--white);
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoActions__fE4w2 button {
  padding: 8px 12px;
  width: 100%;
  justify-content: start;
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoActions__fE4w2 button:hover {
  text-decoration: none;
  background: var(--bg3);
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_groupInfoActions__fE4w2 button span {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
}
.ChatPageV2_groupInfo__MkVgC .ChatPageV2_chatListContainer__4d3uK {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.ChatPageV2_groupInfoHeader__CVAsh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
  padding: 12px 24px;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: var(--white);
}
.ChatPageV2_groupInfoHeader__CVAsh .ChatPageV2_title__j7HY4 {
  font: var(--body-font-one);
  font-weight: 600;
}
.ChatPageV2_groupInfoHeader__CVAsh .ChatPageV2_close__QSWPV {
  width: 20px;
}

.ChatPageV2_groupSearchContainer__uL6rf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  gap: 8px;
}
.ChatPageV2_groupSearchContainer__uL6rf.ChatPageV2_chatMembersModal__sojOa {
  padding: 12px 0;
}

/* Scrollbar styling */
.ChatPageV2_chatList__FP1sx::-webkit-scrollbar,
.ChatPageV2_messagesContainer__snSh8::-webkit-scrollbar {
  width: 6px;
}

.ChatPageV2_chatList__FP1sx::-webkit-scrollbar-track,
.ChatPageV2_messagesContainer__snSh8::-webkit-scrollbar-track {
  background: transparent;
}

.ChatPageV2_chatList__FP1sx::-webkit-scrollbar-thumb,
.ChatPageV2_messagesContainer__snSh8::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.ChatPageV2_chatList__FP1sx::-webkit-scrollbar-thumb:hover,
.ChatPageV2_messagesContainer__snSh8::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .ChatPageV2_groupModal__e82tK {
    padding-bottom: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/chat/ChatPageV2.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAMhB;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAJD;;AAOA;EACC,wBAAA;EACA,sCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAJD;AAMC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAJF;AAOC;EACC,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AALF;AAQC;EAtBD;IAuBE,kBAAA;EALA;AACF;AAOC;EA1BD;IA2BE,gBAAA;EAJA;EAMA;IACC,eAAA;EAJD;AACF;;AAQA;EACC,UAAA;AALD;AAOC;EACC,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AALF;;AASA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;AAND;AAQC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AANF;;AAUA;EACC,aAAA;AAPD;AASC;EAHD;IAIE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IACA,sBAAA;IACA,kBAAA;IACA,eAAA;IACA,eAAA;IACA,yBAAA;EANA;EAQA;IACC,yBAAA;EAND;AACF;;AAUA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAPD;AASC;EACC,4BAAA;EACA,eAAA;EACA,gBAAA;AAPF;AAUC;EAXD;IAYE,SAAA;EAPA;EASA;IACC,aAAA;EAPD;AACF;;AAWA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;AARD;AAUC;EAPD;IAQE,eAAA;EAPA;AACF;;AAUA,YAAA;AACA;EACC,YAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AAPD;AASC;EAPD;IAQE,YAAA;EANA;AACF;AAQC;EAXD;IAYE,YAAA;EALA;AACF;AAOC;EAfD;IAgBE,WAAA;EAJA;AACF;;AAQC;EADD;IAEE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,4BAAA;IACA,+BAAA;EAJA;EAMA;IACC,wBAAA;EAJD;AACF;;AAQA;EACC,kBAAA;EACA,sCAAA;AALD;AAOC;EAJD;IAKE,kBAAA;EAJA;AACF;AAMC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AAJF;AAOC;EACC,SAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AALF;AAOE;EACC,uBAAA;AALH;AAQE;EACC,wBAAA;EACA,mBAAA;EACA,gBAAA;AANH;AAQG;EACC,qBAAA;AANJ;AAUE;EAEC,aAAA;EACA,gBAAA;AATH;AAYE;EApCD;IAqCE,eAAA;EATD;AACF;AAYC;EACC,mBAAA;AAVF;AAYE;EACC,wBAAA;EACA,mBAAA;EACA,gBAAA;AAVH;;AAgBA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,8CAAA;AAbD;;AAgBA;EAEC;IAEC,UAAA;IACA,mBAAA;EAfA;EAkBD;IACC,YAAA;IACA,qBAAA;EAhBA;AACF;AAoBC;EACC,SAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAlBF;AAoBE;EACC,wBAAA;EACA,mBAAA;EACA,gBAAA;AAlBH;AAsBC;EACC,mBAAA;AApBF;AAsBE;EACC,wBAAA;EACA,mBAAA;EACA,gBAAA;AApBH;;AAyBA;EACC,kBAAA;AAtBD;AAwBC;EAHD;IAIE,kBAAA;EArBA;AACF;;AAyBC;EACC,UAAA;EACA,oBAAA;AAtBF;AAyBC;EACC,UAAA;AAvBF;AAyBE;EACC,8BAAA;EACA,+BAAA;AAvBH;AAyBG;EACC,WAAA;EACA,YAAA;AAvBJ;;AA6BA;EACC,UAAA;AA1BD;;AA6BA;EACC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AA1BD;AA4BC;EAdD;IAeE,eAAA;EAzBA;AACF;AA2BC;EACC,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAzBF;AA2BE;EACC,sBAAA;AAzBH;AA4BE;EACC,sBAAA;AA1BH;AA6BE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AA3BH;AA6BG;EARD;IASE,WAAA;IACA,YAAA;IACA,iBAAA;EA1BF;AACF;AA6BG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA3BJ;AA+BG;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,uBAAA;EACA,8BAAA;AA7BJ;AAgCG;EACC,kBAAA;AA9BJ;AAiCG;EACC,0BAAA;AA/BJ;AAkCG;EACC,8BAAA;AAhCJ;AAmCG;EACC,0BAAA;AAjCJ;AAqCE;EACC,SAAA;EACA,YAAA;AAnCH;AAqCG;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnCJ;AAqCI;EATD;IAUE,eAAA;EAlCH;AACF;AAqCG;EACC,eAAA;EACA,4BAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAnCJ;AAqCI;EAVD;IAWE,eAAA;EAlCH;AACF;AAsCE;EACC,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AApCH;AAuCE;EACC,eAAA;EACA,cAAA;EACA,cAAA;AArCH;AAwCE;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtCH;;AA4CC;EACC,MAAA;AAzCF;AA4CC;EACC,iBAAA;AA1CF;AA4CE;EAEC,uBAAA;AA3CH;AA8CE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA5CH;AA8CG;EAND;IAOE,WAAA;IACA,YAAA;IACA,iBAAA;EA3CF;AACF;;AAiDA,gBAAA;AACA;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,wBAAA;EACA,YAAA;AA9CD;;AAiDA;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;AA9CD;AAgDC;EATD;IAUE,kBAAA;IACA,gBAAA;EA7CA;AACF;AA+CC;EACC,aAAA;AA7CF;AA+CE;EAHD;IAIE,aAAA;EA5CD;AACF;AA+CC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AA7CF;AA+CE;EAPD;IAQE,WAAA;IACA,YAAA;IACA,iBAAA;EA5CD;AACF;AAgDC;EACC,SAAA;AA9CF;AAgDE;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA9CH;AAgDG;EAND;IAOE,eAAA;EA7CF;AACF;AAgDE;EACC,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;AA9CH;AAgDG;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AA9CJ;AAiDG;EACC,qBAAA;AA/CJ;AAiDI;EACC,0BAAA;AA/CL;AAmDG;EACC,yBAAA;AAjDJ;AAmDI;EACC,8BAAA;AAjDL;AAqDG;EACC,qBAAA;AAnDJ;AAqDI;EACC,0BAAA;AAnDL;AAyDC;EACC,wCAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AAvDF;AAyDE;EACC,UAAA;AAvDH;AA2DC;EA1GD;IA2GE,kBAAA;IACA,gBAAA;EAxDA;EA0DA;IACC,WAAA;IACA,YAAA;EAxDD;EA2DA;IACC,eAAA;EAzDD;EA4DA;IACC,eAAA;EA1DD;AACF;;AA8DA;EACC,SAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AA3DD;AA6DC;EATD;IAUE,kBAAA;EA1DA;AACF;;AA6DA;EACC,mBAAA;AA1DD;AA4DC;EAHD;IAIE,mBAAA;EAzDA;AACF;AA4DE;EACC,2BAAA;EACA,uBAAA;EACA,QAAA;AA1DH;AA8DG;EACC,sBAAA;EACA,cAAA;EACA,sBAAA;AA5DJ;AAkEE;EACC,yBAAA;EACA,qBAAA;EACA,QAAA;AAhEH;AAmEE;EACC,QAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAjEH;AAmEG;EAND;IAOE,gBAAA;EAhEF;AACF;AAoEE;EACC,qBAAA;AAlEH;AAsEG;EACC,wBAAA;EACA,mBAAA;EACA,sBAAA;AApEJ;AAwEE;EACC,iBAAA;AAtEH;;AA2EA;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;AAxED;;AA2EA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAxED;AA0EC;EATD;IAUE,iBAAA;EAvEA;AACF;;AA2EA;EACC,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AAxED;;AA+EA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AA5ED;;AAgFA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AA7ED;;AAgFA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AA7ED;AA+EC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,qBAAA;AA7EF;AAgFC;EAfD;IAgBE,cAAA;EA7EA;AACF;;AAiFC;EACC,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AA9EF;AAgFE;EACC,gBAAA;AA9EH;;AAmFA;EACC,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAhFD;;AAmFA,qBAAA;AACA;EACC,cAAA;EACA,kBAAA;AAhFD;AAkFC;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhFF;AAkFE;EARD;IASE,YAAA;IACA,aAAA;EA/ED;AACF;AAkFC;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAhFF;AAkFE;EAPD;IAQE,YAAA;IACA,aAAA;EA/ED;AACF;AAkFC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,gCAAA;AAhFF;AAkFE;EACC,oCAAA;AAhFH;AAmFE;EACC,WAAA;EACA,YAAA;AAjFH;AAoFE;EACC,eAAA;EACA,gBAAA;AAlFH;;AAuFA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AApFD;AAsFC;EACC,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AApFF;AAuFC;EACC,uBAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AArFF;AAuFE;EACC,0BAAA;AArFH;;AA0FA;EACC,kBAAA;EACA,cAAA;EACA,kBAAA;AAvFD;AAyFC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;AAvFF;AA0FC;EACC,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,+BAAA;EACA,oBAAA;AAxFF;;AA4FA,kBAAA;AACA;EACC,kBAAA;EACA,qBAAA;AAzFD;;AA4FA;EACC,iBAAA;EACA,YAAA;AAzFD;;AA4FA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;AAzFD;;AA4FA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAzFD;;AA4FA;EACC,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,sDAAA;AAzFD;;AA4FA;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AAzFD;;AA4FA;EACC;IACC,yBAAA;EAzFA;AACF;AA4FA,eAAA;AACA;EACC,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EAcA,yCAAA;EAwCA,yBAAA;AA9ID;AA0FC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAxFF;AA2FC;EACC,uBAAA;EACA,YAAA;EACA,mBAAA;AAzFF;AA6FC;EACC,SAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,+BAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;AA3FF;AA6FE;EAVD;IAWE,mBAAA;EA1FD;AACF;AA4FE;EACC,mCAAA;EACA,6CAAA;AA1FH;AA6FE;EACC,SAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;AA3FH;AA6FG;EATD;IAUE,kBAAA;IACA,aAAA;EA1FF;AACF;AA4FG;EACC,yBAAA;AA1FJ;AAgGC;EA9DD;IA+DE,kBAAA;IACA,QAAA;EA7FA;EA+FA;;IAIC,aAAA;IACA,mBAAA;IACA,uBAAA;EA/FD;EAkGA;IACC,mBAAA;EAhGD;EAkGC;IACC,eAAA;EAhGF;AACF;;AAqGA,gBAAA;AACA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,4BAAA;AAlGD;AAoGC;EACC,eAAA;EACA,mBAAA;EACA,YAAA;AAlGF;AAqGC;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAnGF;AAsGC;EACC,eAAA;EACA,SAAA;EACA,YAAA;AApGF;;AAwGA,mBAAA;AACA;EACC,aAAA;AArGD;AAuGC;EAHD;IAIE,cAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,uBAAA;IACA,UAAA;IACA,UAAA;IACA,oBAAA;IACA,6BAAA;EApGA;EAsGA;IACC,UAAA;IACA,oBAAA;EApGD;AACF;;AAwGA,oBAAA;AAEC;EACC;IACC,wBAAA;EAtGD;AACF;;AA0GA;EACC,qCAAA;EACA,oCAAA;EACA,8BAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAvGD;AAyGC;EACC,wBAAA;EACA,YAAA;EACA,oBAAA;AAvGF;AA0GC;EAjBD;IAkBE,kBAAA;IACA,YAAA;IACA,MAAA;IACA,QAAA;IACA,UAAA;EAvGA;AACF;AAyGC;EAzBD;IA0BE,kBAAA;IACA,YAAA;EAtGA;AACF;AAwGC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AAtGF;AAwGE;EACC,WAAA;EACA,YAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AAtGH;AAwGG;EACC,2BAAA;AAtGJ;AA0GE;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxGH;AA0GG;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;AAxGJ;AA6GG;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;AA5GJ;AA8GI;EACC,WAAA;EACA,YAAA;EACA,eAAA;AA5GL;AAgHG;EACC,SAAA;EACA,eAAA;EACA,2BAAA;EACA,4BAAA;AA9GJ;AAmHC;EACC,4BAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AAjHF;AAmHE;EACC,iBAAA;EACA,WAAA;EACA,sBAAA;AAjHH;AAmHG;EACC,qBAAA;EACA,sBAAA;AAjHJ;AAoHG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAlHJ;AAuHC;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AArHF;;AAyHA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,8BAAA;AAtHD;AAwHC;EACC,0BAAA;EACA,gBAAA;AAtHF;AAyHC;EACC,WAAA;AAvHF;;AA2HA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;AAxHD;AA0HC;EACC,eAAA;AAxHF;;AA4HA,sBAAA;AACA;;EAEC,UAAA;AAzHD;;AA4HA;;EAEC,uBAAA;AAzHD;;AA4HA;;EAEC,mBAAA;EACA,kBAAA;AAzHD;;AA4HA;;EAEC,mBAAA;AAzHD;;AA4HA;EACC;IACC,oBAAA;EAzHA;AACF","sourcesContent":["// Breakpoints\r\n$mobile: 768px;\r\n$tablet: 1024px;\r\n$laptop: 1280px;\r\n$desktop: 1440px;\r\n\r\n.chatPage {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\theight: calc(100dvh - 64px);\r\n\tbackground: var(--white);\r\n\tfont-family: var(--font-inter);\r\n\tposition: relative;\r\n\toverflow-x: hidden;\r\n}\r\n\r\n.pageHeader {\r\n\tbackground: var(--white);\r\n\tborder-bottom: 1px solid var(--border);\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 20px;\r\n\r\n\t.headerLeft {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 12px;\r\n\t}\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tmargin: 0;\r\n\t}\r\n\r\n\t@media (max-width: $laptop) {\r\n\t\tpadding: 10px 15px;\r\n\t}\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\tmin-height: 64px;\r\n\r\n\t\th1 {\r\n\t\t\tfont-size: 24px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.groupModal {\r\n\tpadding: 0;\r\n\r\n\t.subHeader {\r\n\t\tfont-weight: 500;\r\n\t\tfont-size: 14px;\r\n\t\tline-height: normal;\r\n\t\tcolor: #9BA4B5;\r\n\t\tmargin-bottom: 8px;\r\n\t}\r\n}\r\n\r\n.groupTitleInput {\r\n\twidth: 100%;\r\n\tborder: none;\r\n\toutline: none;\r\n\tbackground: transparent;\r\n\tfont-weight: 700;\r\n\tfont-size: 20px;\r\n\tline-height: 25px;\r\n\tcolor: #000;\r\n\ttext-transform: capitalize;\r\n\tpadding-left: 0;\r\n\tmargin-bottom: 12px;\r\n\r\n\t&::placeholder {\r\n\t\tfont-weight: 700;\r\n\t\tfont-size: 20px;\r\n\t\tline-height: 25px;\r\n\t\tcolor: #98a2b1;\r\n\t}\r\n}\r\n\r\n.mobileMenuBtn {\r\n\tdisplay: none;\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\twidth: 40px;\r\n\t\theight: 40px;\r\n\t\tborder: none;\r\n\t\tbackground: var(--bg3);\r\n\t\tborder-radius: 8px;\r\n\t\tcursor: pointer;\r\n\t\tfont-size: 18px;\r\n\t\tcolor: var(--placeholder);\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground: var(--border);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.pageHeaderRight {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 24px;\r\n\r\n\t.dateText {\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 500;\r\n\t}\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\tgap: 12px;\r\n\r\n\t\t.dateText {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.chatWrapper {\r\n\tdisplay: flex;\r\n\tflex: 1;\r\n\toverflow: hidden;\r\n\tbackground: var(--white);\r\n\tposition: relative;\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\tposition: unset;\r\n\t}\r\n}\r\n\r\n/* Sidebar */\r\n.chatSidebar {\r\n\twidth: 360px;\r\n\tborder-right: 1px solid var(--border);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tbackground: var(--white);\r\n\r\n\t@media (max-width: $laptop) {\r\n\t\twidth: 300px;\r\n\t}\r\n\r\n\t@media (max-width: $tablet) {\r\n\t\twidth: 260px;\r\n\t}\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\twidth: 100%;\r\n\t}\r\n}\r\n\r\n.chatWindow {\r\n\t@media (max-width: $mobile) {\r\n\t\tposition: absolute;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\theight: 100%;\r\n\t\twidth: 100%;\r\n\t\tmax-width: 100%;\r\n\t\tz-index: 1;\r\n\t\ttransform: translateX(-100%);\r\n\t\ttransition: transform 0.3s ease;\r\n\r\n\t\t&.open {\r\n\t\t\ttransform: translateX(0);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.sidebarTabs {\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\r\n\t@media (max-width: $laptop) {\r\n\t\tpadding: 10px 15px;\r\n\t}\r\n\r\n\t.tabs {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: space-between;\r\n\t\tgap: 3px;\r\n\t\tpadding: 4px;\r\n\t\tbackground: var(--bg3);\r\n\t\tborder-radius: 12px;\r\n\t}\r\n\r\n\tbutton {\r\n\t\tflex: 1;\r\n\t\tpadding: 4px 8px;\r\n\t\tborder: none;\r\n\t\tbackground: transparent;\r\n\t\tcursor: pointer;\r\n\t\tborder-radius: 12px;\r\n\t\tfont-size: 15px;\r\n\t\tfont-weight: 500;\r\n\t\tcolor: var(--secondary-Text);\r\n\t\ttransition: all 0.2s ease;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tgap: 8px;\r\n\r\n\t\timg {\r\n\t\t\tfilter: grayscale(100%);\r\n\t\t}\r\n\r\n\t\t&.active {\r\n\t\t\tbackground: var(--white);\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tfont-weight: 600;\r\n\r\n\t\t\timg {\r\n\t\t\t\tfilter: grayscale(0%);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&:focus-visible,\r\n\t\t&:focus {\r\n\t\t\toutline: none;\r\n\t\t\tbox-shadow: none;\r\n\t\t}\r\n\r\n\t\t@media (max-width: $laptop) {\r\n\t\t\tfont-size: 12px;\r\n\t\t}\r\n\t}\r\n\r\n\timg {\r\n\t\tcolor: var(--brand);\r\n\r\n\t\t&.active {\r\n\t\t\tbackground: var(--white);\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tfont-weight: 600;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Tab indicator for new messages\r\n.tabIndicator {\r\n\tposition: absolute;\r\n\ttop: 8px;\r\n\tright: 8px;\r\n\twidth: 8px;\r\n\theight: 8px;\r\n\tbackground: #ff3b30;\r\n\tborder-radius: 50%;\r\n\tborder: 2px solid var(--white);\r\n\tanimation: pulse 2s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n\r\n\t0%,\r\n\t100% {\r\n\t\topacity: 1;\r\n\t\ttransform: scale(1);\r\n\t}\r\n\r\n\t50% {\r\n\t\topacity: 0.7;\r\n\t\ttransform: scale(1.1);\r\n\t}\r\n}\r\n\r\n.sidebarButton {\r\n\tbutton {\r\n\t\tflex: 1;\r\n\t\tpadding: 4px 8px;\r\n\t\tborder: none;\r\n\t\tbackground: transparent;\r\n\t\tcursor: pointer;\r\n\t\tborder-radius: 12px;\r\n\t\tfont-size: 15px;\r\n\t\tfont-weight: 500;\r\n\t\tcolor: var(--brand);\r\n\t\ttransition: all 0.2s ease;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tgap: 8px;\r\n\r\n\t\t&.active {\r\n\t\t\tbackground: var(--white);\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tfont-weight: 600;\r\n\t\t}\r\n\t}\r\n\r\n\timg {\r\n\t\tcolor: var(--brand);\r\n\r\n\t\t&.active {\r\n\t\t\tbackground: var(--white);\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tfont-weight: 600;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.searchContainer {\r\n\tpadding: 20px 24px;\r\n\r\n\t@media (max-width: $laptop) {\r\n\t\tpadding: 10px 15px;\r\n\t}\r\n}\r\n\r\n.modalBody {\r\n\t.searchContainer {\r\n\t\tpadding: 0;\r\n\t\tpadding-bottom: 20px;\r\n\t}\r\n\r\n\t.chatList {\r\n\t\tpadding: 0;\r\n\r\n\t\t.chatItem {\r\n\t\t\tbackground-color: var(--white);\r\n\t\t\tborder: 1px solid var(--border);\r\n\r\n\t\t\t.avatar {\r\n\t\t\t\twidth: 38px;\r\n\t\t\t\theight: 38px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.groupModal {\r\n\tpadding: 0;\r\n}\r\n\r\n.chatList {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\toverflow-y: auto;\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\tjustify-content: start;\r\n\talign-items: center;\r\n\tflex-direction: column;\r\n\tgap: 8px;\r\n\tmax-width: 100%;\r\n\tpadding: 0 24px;\r\n\r\n\t@media (max-width: $laptop) {\r\n\t\tpadding: 0 15px;\r\n\t}\r\n\r\n\t.chatItem {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tpadding: 8px 12px;\r\n\t\tcursor: pointer;\r\n\t\ttransition: background-color 0.2s ease;\r\n\t\tposition: relative;\r\n\t\tborder-radius: 8px;\r\n\t\twidth: 100%;\r\n\t\tmax-width: 100%;\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground: var(--bg3);\r\n\t\t}\r\n\r\n\t\t&.selected {\r\n\t\t\tbackground: var(--bg3);\r\n\t\t}\r\n\r\n\t\t.avatar {\r\n\t\t\tposition: relative;\r\n\t\t\twidth: 48px;\r\n\t\t\theight: 48px;\r\n\t\t\tmargin-right: 16px;\r\n\t\t\tflex-shrink: 0;\r\n\t\t\tdisplay: inline-block;\r\n\r\n\t\t\t@media (max-width: $laptop) {\r\n\t\t\t\twidth: 35px;\r\n\t\t\t\theight: 35px;\r\n\t\t\t\tmargin-right: 8px;\r\n\r\n\t\t\t}\r\n\r\n\t\t\t&__img {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t\t// display: block;\r\n\t\t\t}\r\n\r\n\t\t\t&::after {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tbottom: 4px;\r\n\t\t\t\tright: 4px;\r\n\t\t\t\ttransform: translate(25%, 25%);\r\n\t\t\t\twidth: 10px;\r\n\t\t\t\theight: 10px;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tborder: 1px solid var(--white);\r\n\t\t\t\tbox-sizing: content-box;\r\n\t\t\t\tbackground: var(--placeholder);\r\n\t\t\t}\r\n\r\n\t\t\t&.group::after {\r\n\t\t\t\tvisibility: hidden;\r\n\t\t\t}\r\n\r\n\t\t\t&.online::after {\r\n\t\t\t\tbackground: var(--success);\r\n\t\t\t}\r\n\r\n\t\t\t&.offline::after {\r\n\t\t\t\tbackground: var(--placeholder);\r\n\t\t\t}\r\n\r\n\t\t\t&.away::after {\r\n\t\t\t\tbackground: var(--warning);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.chatInfo {\r\n\t\t\tflex: 1;\r\n\t\t\tmin-width: 0;\r\n\r\n\t\t\t.userName {\r\n\t\t\t\tfont-size: 16px;\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: #1e293b;\r\n\t\t\t\tmargin: 0 0 4px 0;\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t\ttext-overflow: ellipsis;\r\n\r\n\t\t\t\t@media (max-width: $laptop) {\r\n\t\t\t\t\tfont-size: 14px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.lastMessage {\r\n\t\t\t\tfont-size: 14px;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tmargin: 0;\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t\tline-height: 1.4;\r\n\t\t\t\ttext-align: start;\r\n\r\n\t\t\t\t@media (max-width: $laptop) {\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.chatMeta {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\talign-items: flex-end;\r\n\t\t\tgap: 6px;\r\n\t\t\tflex-shrink: 0;\r\n\t\t\tmargin-left: 12px;\r\n\t\t}\r\n\r\n\t\t.timeStamp {\r\n\t\t\tfont-size: 13px;\r\n\t\t\tcolor: #94a3b8;\r\n\t\t\tflex-shrink: 0;\r\n\t\t}\r\n\r\n\t\t.unreadBadge {\r\n\t\t\tdisplay: inline-flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\tmin-width: 20px;\r\n\t\t\theight: 20px;\r\n\t\t\tpadding: 0 6px;\r\n\t\t\tbackground: #10B981;\r\n\t\t\tcolor: white;\r\n\t\t\tborder-radius: 10px;\r\n\t\t\tfont-size: 12px;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tline-height: 1;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.chatListGroup {\r\n\t&.chatList {\r\n\t\tgap: 0;\r\n\t}\r\n\r\n\t.chatItem {\r\n\t\tpadding: 8px 12px;\r\n\r\n\t\t&:hover,\r\n\t\t&.selected {\r\n\t\t\tbackground: transparent;\r\n\t\t}\r\n\r\n\t\t.avatar {\r\n\t\t\tposition: relative;\r\n\t\t\twidth: 40px;\r\n\t\t\theight: 40px;\r\n\t\t\tmargin-right: 12px;\r\n\r\n\t\t\t@media (max-width: $laptop) {\r\n\t\t\t\twidth: 30px;\r\n\t\t\t\theight: 30px;\r\n\t\t\t\tmargin-right: 8px;\r\n\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n/* Chat Window */\r\n.chatWindow {\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tmin-width: 0;\r\n\tbackground: var(--white);\r\n\theight: 100%;\r\n}\r\n\r\n.chatHeader {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tpadding: 18px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tbackground: var(--white);\r\n\tmin-height: 80px;\r\n\twidth: 100%;\r\n\r\n\t@media (max-width: $laptop) {\r\n\t\tpadding: 10px 15px;\r\n\t\tmin-height: 69px;\r\n\t}\r\n\r\n\t.arrowBack {\r\n\t\tdisplay: none;\r\n\r\n\t\t@media (max-width: $mobile) {\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\t}\r\n\r\n\t.avatar {\r\n\t\twidth: 44px;\r\n\t\theight: 44px;\r\n\t\tborder-radius: 50%;\r\n\t\tmargin-right: 16px;\r\n\t\tobject-fit: cover;\r\n\r\n\t\t@media (max-width: $laptop) {\r\n\t\t\twidth: 30px;\r\n\t\t\theight: 30px;\r\n\t\t\tmargin-right: 8px;\r\n\r\n\t\t}\r\n\t}\r\n\r\n\t.userInfo {\r\n\t\tflex: 1;\r\n\r\n\t\t.userName {\r\n\t\t\tfont-size: 20px;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #1e293b;\r\n\t\t\tmargin: 0;\r\n\r\n\t\t\t@media (max-width: $laptop) {\r\n\t\t\t\tfont-size: 18px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.userStatus {\r\n\t\t\tfont-size: 14px;\r\n\t\t\tmargin: 0;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\ttext-transform: capitalize;\r\n\r\n\t\t\t&::before {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\twidth: 8px;\r\n\t\t\t\theight: 8px;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tdisplay: inline-block;\r\n\t\t\t}\r\n\r\n\t\t\t&.online {\r\n\t\t\t\tcolor: var(--success);\r\n\r\n\t\t\t\t&::before {\r\n\t\t\t\t\tbackground: var(--success);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.offline {\r\n\t\t\t\tcolor: var(--placeholder);\r\n\r\n\t\t\t\t&::before {\r\n\t\t\t\t\tbackground: var(--placeholder);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.away {\r\n\t\t\t\tcolor: var(--warning);\r\n\r\n\t\t\t\t&::before {\r\n\t\t\t\t\tbackground: var(--warning);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.headerActions {\r\n\t\tbackground-color: transparent !important;\r\n\t\tborder: transparent !important;\r\n\t\tcolor: var(--white) !important;\r\n\t\tbox-shadow: none !important;\r\n\t\twidth: 20px;\r\n\t\theight: 20px;\r\n\r\n\t\tspan {\r\n\t\t\tpadding: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\tpadding: 16px 20px;\r\n\t\tmin-height: 64px;\r\n\r\n\t\t.avatar {\r\n\t\t\twidth: 44px;\r\n\t\t\theight: 44px;\r\n\t\t}\r\n\r\n\t\t.userName {\r\n\t\t\tfont-size: 18px;\r\n\t\t}\r\n\r\n\t\t.userStatus {\r\n\t\t\tfont-size: 13px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.messagesContainer {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\tpadding: 24px;\r\n\tbackground: var(--white);\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tflex-direction: column-reverse;\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\tpadding: 16px 20px;\r\n\t}\r\n}\r\n\r\n.messageGroup {\r\n\tmargin-bottom: 24px;\r\n\r\n\t@media (max-width: $laptop) {\r\n\t\tmargin-bottom: 18px;\r\n\t}\r\n\r\n\t&.received {\r\n\t\t.messageWrapper {\r\n\t\t\tjustify-content: flex-start;\r\n\t\t\talign-items: flex-start;\r\n\t\t\tgap: 7px;\r\n\t\t}\r\n\r\n\t\t.message {\r\n\t\t\t.messageBubble {\r\n\t\t\t\tbackground: var(--bg3);\r\n\t\t\t\tcolor: #1e293b;\r\n\t\t\t\tword-break: break-word;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.sent {\r\n\t\t.messageWrapper {\r\n\t\t\tjustify-content: flex-end;\r\n\t\t\talign-items: flex-end;\r\n\t\t\tgap: 7px;\r\n\t\t}\r\n\r\n\t\t.messageAvatar {\r\n\t\t\torder: 2;\r\n\t\t\tmargin-left: 16px;\r\n\t\t\tmargin-right: 0;\r\n\t\t\tmargin-bottom: 22px;\r\n\r\n\t\t\t@media (max-width: $laptop) {\r\n\t\t\t\tmargin-left: 6px;\r\n\t\t\t}\r\n\r\n\t\t}\r\n\r\n\t\t.messageContent {\r\n\t\t\talign-items: flex-end;\r\n\t\t}\r\n\r\n\t\t.message {\r\n\t\t\t.messageBubble {\r\n\t\t\t\tbackground: var(--brand);\r\n\t\t\t\tcolor: var(--white);\r\n\t\t\t\tword-break: break-word;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.messageTime {\r\n\t\t\ttext-align: right;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.messageWrapper {\r\n\tdisplay: flex;\r\n\talign-items: flex-start;\r\n\tmargin-bottom: 4px;\r\n}\r\n\r\n.messageAvatar {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tborder-radius: 50%;\r\n\tmargin-right: 16px;\r\n\tflex-shrink: 0;\r\n\tobject-fit: cover;\r\n\tmargin-bottom: 22px;\r\n\r\n\t@media (max-width: $laptop) {\r\n\t\tmargin-right: 6px;\r\n\t}\r\n}\r\n\r\n// Avatar wrapper for online indicator\r\n.avatarWrapper {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\tmargin-right: 0;\r\n\tflex-shrink: 0;\r\n\t// margin-bottom: 22px;\r\n\r\n\r\n}\r\n\r\n// Online indicator for group chat members\r\n.onlineIndicator {\r\n\tposition: absolute;\r\n\tbottom: 20px;\r\n\tright: 16px;\r\n\twidth: 12px;\r\n\theight: 12px;\r\n\tbackground: #10b981;\r\n\tborder: 2px solid var(--white);\r\n\tborder-radius: 50%;\r\n\tz-index: 1;\r\n}\r\n\r\n// Away indicator for group chat members (yellow/orange)\r\n.awayIndicator {\r\n\tposition: absolute;\r\n\tbottom: 22px;\r\n\tright: 16px;\r\n\twidth: 12px;\r\n\theight: 12px;\r\n\tbackground: #f59e0b;\r\n\tborder: 2px solid var(--white);\r\n\tborder-radius: 50%;\r\n\tz-index: 1;\r\n}\r\n\r\n.messageContent {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: flex-start;\r\n\tmax-width: 65%;\r\n\r\n\t.senderName {\r\n\t\tfont-size: 13px;\r\n\t\tfont-weight: 700;\r\n\t\tmargin-bottom: 10px;\r\n\t\tcolor: var(--brand);\r\n\t\ttext-transform: capitalize;\r\n\t\tletter-spacing: 0.3px;\r\n\t}\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\tmax-width: 80%;\r\n\t}\r\n}\r\n\r\n.message {\r\n\t.messageBubble {\r\n\t\tpadding: 8px 16px;\r\n\t\tborder-radius: 12px;\r\n\t\tfont-size: 15px;\r\n\t\tline-height: 1.4;\r\n\t\tword-wrap: break-word;\r\n\t\tmargin-bottom: 10px;\r\n\t\twidth: fit-content;\r\n\r\n\t\t&:last-child {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.messageTime {\r\n\tfont-size: 12px;\r\n\tcolor: #94a3b8;\r\n\tmargin-top: 10px;\r\n\tpadding: 0 6px;\r\n}\r\n\r\n/* File Attachments */\r\n.fileAttachment {\r\n\tmargin: 0 -8px;\r\n\tmargin-bottom: 8px;\r\n\r\n\t.attachedImage {\r\n\t\twidth: 280px;\r\n\t\theight: 280px;\r\n\t\tborder-radius: 10px;\r\n\t\tcursor: pointer;\r\n\t\tobject-fit: cover;\r\n\t\tdisplay: block;\r\n\r\n\t\t@media (max-width: $mobile) {\r\n\t\t\twidth: 220px;\r\n\t\t\theight: 220px;\r\n\t\t}\r\n\t}\r\n\r\n\t.attachedVideo {\r\n\t\twidth: 280px;\r\n\t\theight: 280px;\r\n\t\tborder-radius: 8px;\r\n\t\tdisplay: block;\r\n\t\tobject-fit: cover;\r\n\r\n\t\t@media (max-width: $mobile) {\r\n\t\t\twidth: 220px;\r\n\t\t\theight: 220px;\r\n\t\t}\r\n\t}\r\n\r\n\t.fileLink {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t\tpadding: 12px 16px;\r\n\t\tbackground: rgba(255, 255, 255, 0.1);\r\n\t\tborder-radius: 8px;\r\n\t\ttext-decoration: none;\r\n\t\tcolor: inherit;\r\n\t\ttransition: background 0.2s ease;\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground: rgba(255, 255, 255, 0.2);\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\twidth: 24px;\r\n\t\t\theight: 24px;\r\n\t\t}\r\n\r\n\t\tspan {\r\n\t\t\tfont-size: 14px;\r\n\t\t\tfont-weight: 500;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.selectedFilePreview {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 8px 12px;\r\n\tbackground: var(--bg3);\r\n\tborder-radius: 8px;\r\n\tmargin-bottom: 8px;\r\n\twidth: 100%;\r\n\r\n\tspan {\r\n\t\tfont-size: 14px;\r\n\t\tcolor: var(--primary-Text);\r\n\t\toverflow: hidden;\r\n\t\ttext-overflow: ellipsis;\r\n\t\twhite-space: nowrap;\r\n\t\tflex: 1;\r\n\t}\r\n\r\n\tbutton {\r\n\t\tbackground: transparent;\r\n\t\tborder: none;\r\n\t\tfont-size: 24px;\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tcursor: pointer;\r\n\t\tpadding: 0;\r\n\t\tmargin-left: 12px;\r\n\t\tline-height: 1;\r\n\r\n\t\t&:hover {\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.dateDivider {\r\n\ttext-align: center;\r\n\tmargin: 32px 0;\r\n\tposition: relative;\r\n\r\n\t&::before {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\ttop: 50%;\r\n\t\tleft: 0;\r\n\t\tright: 0;\r\n\t\theight: 1px;\r\n\t\tbackground: var(--border);\r\n\t}\r\n\r\n\tspan {\r\n\t\tbackground: var(--white);\r\n\t\tpadding: 4px 12px;\r\n\t\tfont-size: 13px;\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tfont-weight: 500;\r\n\t\tposition: relative;\r\n\t\tz-index: 1;\r\n\t\tborder: 1px solid var(--border);\r\n\t\tborder-radius: 500px;\r\n\t}\r\n}\r\n\r\n/* Upload Loader */\r\n.uploadingMediaWrapper {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.uploading {\r\n\tfilter: blur(4px);\r\n\topacity: 0.5;\r\n}\r\n\r\n.uploadOverlay {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tbackground: rgba(0, 0, 0, 0.4);\r\n\tborder-radius: 8px;\r\n}\r\n\r\n.loaderContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tgap: 12px;\r\n}\r\n\r\n.circularLoader {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tborder: 5px dotted var(--white);\r\n\tborder-radius: 50%;\r\n\tanimation: spin 1.2s linear infinite;\r\n}\r\n\r\n.uploadingText {\r\n\tcolor: var(--white);\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\ttext-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n@keyframes spin {\r\n\tto {\r\n\t\ttransform: rotate(360deg);\r\n\t}\r\n}\r\n\r\n/* Chat Input */\r\n.chatInput {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tbackground: var(--white);\r\n\tpadding: 24px;\r\n\tpadding-top: 5px;\r\n\tgap: 12px;\r\n\twidth: 100%;\r\n\r\n\t.chatInputAttachBtn {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t}\r\n\r\n\t.chatInputBtn {\r\n\t\tbackground: transparent;\r\n\t\tborder: none;\r\n\t\tpadding-right: 20px;\r\n\t}\r\n\r\n\t/* Input Wrapper (contains text + send) */\r\n\t.inputWrapper {\r\n\t\tflex: 1;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tbackground: var(--white);\r\n\t\tborder: 1px solid var(--border);\r\n\t\tborder-radius: 24px;\r\n\t\tpadding: 0;\r\n\t\ttransition: all 0.2s ease;\r\n\r\n\t\t@media (max-width: $laptop) {\r\n\t\t\tborder-radius: 18px;\r\n\t\t}\r\n\r\n\t\t&:focus-within {\r\n\t\t\tborder-color: var(--secondary-Text);\r\n\t\t\tbox-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n\t\t}\r\n\r\n\t\tinput {\r\n\t\t\tflex: 1;\r\n\t\t\tborder: none;\r\n\t\t\tbackground: transparent;\r\n\t\t\tfont-size: 15px;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tpadding: 15px 20px;\r\n\t\t\toutline: none;\r\n\r\n\t\t\t@media (max-width: $laptop) {\r\n\t\t\t\tpadding: 10px 15px;\r\n\t\t\t\tmargin: 7px 0;\r\n\t\t\t}\r\n\r\n\t\t\t&::placeholder {\r\n\t\t\t\tcolor: var(--placeholder);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t/* 📱 Mobile Responsive */\r\n\t@media (max-width: 768px) {\r\n\t\tpadding: 24px 20px;\r\n\t\tgap: 8px;\r\n\r\n\t\t.chatInputAttachBtn,\r\n\t\t.chatInputBtn {\r\n\t\t\t// width: 40px;\r\n\t\t\t// height: 40px;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t}\r\n\r\n\t\t.inputWrapper {\r\n\t\t\tborder-radius: 20px;\r\n\r\n\t\t\tinput {\r\n\t\t\t\tfont-size: 14px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n/* Empty state */\r\n.emptyState {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tflex: 1;\r\n\ttext-align: center;\r\n\tpadding: 40px;\r\n\tcolor: var(--secondary-Text);\r\n\r\n\t.emptyIcon {\r\n\t\tfont-size: 64px;\r\n\t\tmargin-bottom: 16px;\r\n\t\topacity: 0.5;\r\n\t}\r\n\r\n\th3 {\r\n\t\tfont-size: 20px;\r\n\t\tfont-weight: 600;\r\n\t\tmargin: 0 0 8px 0;\r\n\t\tcolor: #334155;\r\n\t}\r\n\r\n\tp {\r\n\t\tfont-size: 16px;\r\n\t\tmargin: 0;\r\n\t\topacity: 0.8;\r\n\t}\r\n}\r\n\r\n/* Mobile overlay */\r\n.mobileOverlay {\r\n\tdisplay: none;\r\n\r\n\t@media (max-width: $tablet) {\r\n\t\tdisplay: block;\r\n\t\tposition: fixed;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tbackground: transparent;\r\n\t\tz-index: 2;\r\n\t\topacity: 0;\r\n\t\tpointer-events: none;\r\n\t\ttransition: opacity 0.3s ease;\r\n\r\n\t\t&.active {\r\n\t\t\topacity: 1;\r\n\t\t\tpointer-events: auto;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n/* Utility classes */\r\n.sidebarOpen {\r\n\t@media (max-width: $mobile) {\r\n\t\t.chatSidebar {\r\n\t\t\ttransform: translateX(0);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.groupInfo {\r\n\tborder-right: 1px solid var(--border);\r\n\tborder-left: 1px solid var(--border);\r\n\tbackground-color: var(--white);\r\n\twidth: 0;\r\n\ttransform: translateX(100%);\r\n\ttransition: all 0.3s;\r\n\theight: 100%;\r\n\tmax-height: 100%;\r\n\toverflow-y: auto;\r\n\r\n\t&.open {\r\n\t\ttransform: translateX(0);\r\n\t\twidth: 310px;\r\n\t\ttransition: all 0.3s;\r\n\t}\r\n\r\n\t@media (max-width: $tablet) {\r\n\t\tposition: absolute;\r\n\t\twidth: 320px;\r\n\t\ttop: 0;\r\n\t\tright: 0;\r\n\t\tz-index: 2;\r\n\t}\r\n\r\n\t@media (max-width: $mobile) {\r\n\t\tposition: absolute;\r\n\t\twidth: 320px;\r\n\t}\r\n\r\n\t.groupInfoDetailsMain {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tgap: 12px;\r\n\t\tpadding: 0 24px;\r\n\t\tpadding-top: 16px;\r\n\r\n\t\t.uploadCircle {\r\n\t\t\twidth: 96px;\r\n\t\t\theight: 96px;\r\n\t\t\tborder-radius: 500px;\r\n\t\t\tborder: 2px solid var(--border);\r\n\t\t\tbackground-color: var(--white);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\ttext-align: center;\r\n\t\t\tcursor: pointer;\r\n\t\t\tposition: relative;\r\n\t\t\tfont: var(--body-font-four);\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cameraIcon {\r\n\t\t\tposition: absolute;\r\n\t\t\tbottom: 0px;\r\n\t\t\tright: 0px;\r\n\t\t\tbackground-color: var(--brand);\r\n\t\t\tcolor: var(--white);\r\n\t\t\tborder-radius: 50%;\r\n\t\t\twidth: 28px;\r\n\t\t\theight: 28px;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\r\n\t\t\timg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: contain;\r\n\t\t\t\tpadding: 4px;\r\n\t\t\t\tfilter: brightness(0) invert(1);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.groupInfoDetails {\r\n\t\t\th3 {\r\n\t\t\t\tfont: var(--h6);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\ttext-align: center;\r\n\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tcursor: pointer;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tmargin: 0;\r\n\t\t\t\tmargin-top: 6px;\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.groupInfoActions {\r\n\t\tpadding: 16px 24px 20px 24px;\r\n\t\tposition: sticky;\r\n\t\tbottom: 0;\r\n\t\tz-index: 1;\r\n\t\tbackground-color: var(--white);\r\n\r\n\t\tbutton {\r\n\t\t\tpadding: 8px 12px;\r\n\t\t\twidth: 100%;\r\n\t\t\tjustify-content: start;\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\ttext-decoration: none;\r\n\t\t\t\tbackground: var(--bg3);\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.chatListContainer {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: space-between;\r\n\t\theight: 100%;\r\n\t}\r\n}\r\n\r\n.groupInfoHeader {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tpadding: 12px 24px;\r\n\tposition: sticky;\r\n\ttop: 0;\r\n\tz-index: 1;\r\n\tbackground-color: var(--white);\r\n\r\n\t.title {\r\n\t\tfont: var(--body-font-one);\r\n\t\tfont-weight: 600;\r\n\t}\r\n\r\n\t.close {\r\n\t\twidth: 20px;\r\n\t}\r\n}\r\n\r\n.groupSearchContainer {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 12px 24px;\r\n\tgap: 8px;\r\n\r\n\t&.chatMembersModal {\r\n\t\tpadding: 12px 0;\r\n\t}\r\n}\r\n\r\n/* Scrollbar styling */\r\n.chatList::-webkit-scrollbar,\r\n.messagesContainer::-webkit-scrollbar {\r\n\twidth: 6px;\r\n}\r\n\r\n.chatList::-webkit-scrollbar-track,\r\n.messagesContainer::-webkit-scrollbar-track {\r\n\tbackground: transparent;\r\n}\r\n\r\n.chatList::-webkit-scrollbar-thumb,\r\n.messagesContainer::-webkit-scrollbar-thumb {\r\n\tbackground: #cbd5e1;\r\n\tborder-radius: 3px;\r\n}\r\n\r\n.chatList::-webkit-scrollbar-thumb:hover,\r\n.messagesContainer::-webkit-scrollbar-thumb:hover {\r\n\tbackground: #94a3b8;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.groupModal {\r\n\t\tpadding-bottom: 15px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatPage": `ChatPageV2_chatPage__gC8c5`,
	"pageHeader": `ChatPageV2_pageHeader__FyWw3`,
	"headerLeft": `ChatPageV2_headerLeft__oIBRg`,
	"groupModal": `ChatPageV2_groupModal__e82tK`,
	"subHeader": `ChatPageV2_subHeader__EKsFQ`,
	"groupTitleInput": `ChatPageV2_groupTitleInput__RhYZ9`,
	"mobileMenuBtn": `ChatPageV2_mobileMenuBtn__33rR8`,
	"pageHeaderRight": `ChatPageV2_pageHeaderRight__swnex`,
	"dateText": `ChatPageV2_dateText__hO2O3`,
	"chatWrapper": `ChatPageV2_chatWrapper__lGSxA`,
	"chatSidebar": `ChatPageV2_chatSidebar__N2d5v`,
	"chatWindow": `ChatPageV2_chatWindow__vC0ww`,
	"open": `ChatPageV2_open__TlPMu`,
	"sidebarTabs": `ChatPageV2_sidebarTabs__mYiba`,
	"tabs": `ChatPageV2_tabs__o4z3B`,
	"active": `ChatPageV2_active__wtETX`,
	"tabIndicator": `ChatPageV2_tabIndicator__hOTZm`,
	"pulse": `ChatPageV2_pulse__Xrb5z`,
	"sidebarButton": `ChatPageV2_sidebarButton__cDszw`,
	"searchContainer": `ChatPageV2_searchContainer__V+NhO`,
	"modalBody": `ChatPageV2_modalBody__GcJmL`,
	"chatList": `ChatPageV2_chatList__FP1sx`,
	"chatItem": `ChatPageV2_chatItem__20RCC`,
	"avatar": `ChatPageV2_avatar__uca20`,
	"selected": `ChatPageV2_selected__0Kqn2`,
	"avatar__img": `ChatPageV2_avatar__img__Atv2-`,
	"group": `ChatPageV2_group__WjKu6`,
	"online": `ChatPageV2_online__7OGTI`,
	"offline": `ChatPageV2_offline__zvj6u`,
	"away": `ChatPageV2_away__J-cEE`,
	"chatInfo": `ChatPageV2_chatInfo__WDAOQ`,
	"userName": `ChatPageV2_userName__StpY6`,
	"lastMessage": `ChatPageV2_lastMessage__kyOB3`,
	"chatMeta": `ChatPageV2_chatMeta__-oyon`,
	"timeStamp": `ChatPageV2_timeStamp__mAMBm`,
	"unreadBadge": `ChatPageV2_unreadBadge__4N4Y6`,
	"chatListGroup": `ChatPageV2_chatListGroup__QxuCW`,
	"chatHeader": `ChatPageV2_chatHeader__w+NWa`,
	"arrowBack": `ChatPageV2_arrowBack__akmsX`,
	"userInfo": `ChatPageV2_userInfo__qjGo3`,
	"userStatus": `ChatPageV2_userStatus__hp0Px`,
	"headerActions": `ChatPageV2_headerActions__NZaE0`,
	"messagesContainer": `ChatPageV2_messagesContainer__snSh8`,
	"messageGroup": `ChatPageV2_messageGroup__YMurl`,
	"received": `ChatPageV2_received__4bDkk`,
	"messageWrapper": `ChatPageV2_messageWrapper__WjBJ9`,
	"message": `ChatPageV2_message__lYn6a`,
	"messageBubble": `ChatPageV2_messageBubble__N9Ncn`,
	"sent": `ChatPageV2_sent__0jCWD`,
	"messageAvatar": `ChatPageV2_messageAvatar__UKM6a`,
	"messageContent": `ChatPageV2_messageContent__fR4zm`,
	"messageTime": `ChatPageV2_messageTime__Rtrxx`,
	"avatarWrapper": `ChatPageV2_avatarWrapper__6vEuG`,
	"onlineIndicator": `ChatPageV2_onlineIndicator__jo4t6`,
	"awayIndicator": `ChatPageV2_awayIndicator__0NxHr`,
	"senderName": `ChatPageV2_senderName__j2jpx`,
	"fileAttachment": `ChatPageV2_fileAttachment__OYJj6`,
	"attachedImage": `ChatPageV2_attachedImage__kMFjv`,
	"attachedVideo": `ChatPageV2_attachedVideo__eYBGg`,
	"fileLink": `ChatPageV2_fileLink__Auiaj`,
	"selectedFilePreview": `ChatPageV2_selectedFilePreview__uxUf0`,
	"dateDivider": `ChatPageV2_dateDivider__LgNZt`,
	"uploadingMediaWrapper": `ChatPageV2_uploadingMediaWrapper__guOXg`,
	"uploading": `ChatPageV2_uploading__4Ehf+`,
	"uploadOverlay": `ChatPageV2_uploadOverlay__YMuQG`,
	"loaderContainer": `ChatPageV2_loaderContainer__NttQX`,
	"circularLoader": `ChatPageV2_circularLoader__3idKn`,
	"spin": `ChatPageV2_spin__km92v`,
	"uploadingText": `ChatPageV2_uploadingText__JKNpl`,
	"chatInput": `ChatPageV2_chatInput__DSL8C`,
	"chatInputAttachBtn": `ChatPageV2_chatInputAttachBtn__Vfz5s`,
	"chatInputBtn": `ChatPageV2_chatInputBtn__eyg+M`,
	"inputWrapper": `ChatPageV2_inputWrapper__1GtV3`,
	"emptyState": `ChatPageV2_emptyState__47tQc`,
	"emptyIcon": `ChatPageV2_emptyIcon__GSvDo`,
	"mobileOverlay": `ChatPageV2_mobileOverlay__f+VbZ`,
	"sidebarOpen": `ChatPageV2_sidebarOpen__nFbt5`,
	"groupInfo": `ChatPageV2_groupInfo__MkVgC`,
	"groupInfoDetailsMain": `ChatPageV2_groupInfoDetailsMain__kDD81`,
	"uploadCircle": `ChatPageV2_uploadCircle__yCRZH`,
	"cameraIcon": `ChatPageV2_cameraIcon__J8ba7`,
	"groupInfoDetails": `ChatPageV2_groupInfoDetails__-7ERv`,
	"groupInfoActions": `ChatPageV2_groupInfoActions__fE4w2`,
	"chatListContainer": `ChatPageV2_chatListContainer__4d3uK`,
	"groupInfoHeader": `ChatPageV2_groupInfoHeader__CVAsh`,
	"title": `ChatPageV2_title__j7HY4`,
	"close": `ChatPageV2_close__QSWPV`,
	"groupSearchContainer": `ChatPageV2_groupSearchContainer__uL6rf`,
	"chatMembersModal": `ChatPageV2_chatMembersModal__sojOa`
};
export default ___CSS_LOADER_EXPORT___;
